import { ArrowUpRight, FileCheck2 } from "lucide-react";
import { Link } from "react-router-dom";
import type { VerifiedFact } from "../types";
import { CopyButton } from "./CopyButton";
import { StatusBadge } from "./StatusBadge";
import { UsageBadge } from "./UsageBadge";
import { WarningCallout } from "./WarningCallout";

export function FactCard({ fact }: { fact: VerifiedFact }) {
  return (
    <article className="fact-card">
      <div className="fact-card__header">
        <span className="fact-card__category"><FileCheck2 size={15} aria-hidden="true" />{fact.category}</span>
        <StatusBadge status={fact.status} />
      </div>
      <div className="fact-card__body">
        <h2>{fact.title}</h2>
        <strong className="fact-card__value">{fact.value}</strong>
        {fact.shortDescription && <p>{fact.shortDescription}</p>}
      </div>
      <div className="fact-card__meta">
        <UsageBadge usage={fact.publicUsage} />
        <span>Источник: {fact.sourceTitle}</span>
      </div>
      {fact.status === "needs-review" && (
        <WarningCallout title="Требует проверки">
          Перед публичным использованием уточните актуальность информации.
        </WarningCallout>
      )}
      <div className="card-actions">
        <CopyButton text={`${fact.title}: ${fact.value}`} />
        <Link className="button button--ghost" to={`/facts/${fact.id}`}>
          Подробнее <ArrowUpRight size={17} aria-hidden="true" />
        </Link>
      </div>
    </article>
  );
}
